import React from 'react';

const NotificationDot = ({ number, color, size }) => (
  <div style={{ width: size, height: size, borderRadius: 100, backgroundColor: color, textAlign: 'center' }}>
    <span style={{ color: 'white' }}>{number}</span>
  </div>
);

export default NotificationDot;
